import { render } from "./Loader.vue?vue&type=template&id=626a63cb&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=626a63cb&lang=scss&scoped=true"

import exportComponent from "/home/m/neurometronomy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626a63cb"]])

export default __exports__